import { useSelector } from "react-redux";
import { fetchAgentMlsIds } from "redux/slice/agent-mls-ids";
import { updateAgent } from "redux/slice/agents";
import { fetchClientBoards } from "redux/slice/client-boards";
import { getAgentById } from "redux/selector";
import { RootState, useAppThunkDispatch } from "redux/store";

// Make Billable turns on the agent's Lead Owner, the same save as the Access tab's. Lead Owner is what makes an agent
// billable, and the MLS ID reads carry it, so both reload after the save. The returned save rejects on a failure.
export const useMakeBillable = (agentId: number | null) => {
	const dispatch = useAppThunkDispatch();
	const agent = useSelector((state: RootState) => (agentId != null ? getAgentById(state, agentId) : undefined));
	return async () => {
		if (!agent) {
			throw new Error("That agent isn't loaded.");
		}
		await dispatch(updateAgent({ agent: { ...agent, ownsLeads: true } })).unwrap();
		dispatch(fetchAgentMlsIds());
		dispatch(fetchClientBoards());
	};
};

export const MAKE_BILLABLE_FAILED = "Something went wrong. Please try again.";
